import { Pipe, PipeTransform } from '@angular/core';

import { Course } from 'lms-api';
import get from 'lodash/get';

@Pipe({
  name: 'courseListSort'
})
export class CourseListSortPipe implements PipeTransform {

  transform(courses: Course[], ...args: any[]): any {
    if(!Array.isArray(courses)) return [];
    const sortable = [...courses];
    let sortInGroups = args[0] ? args[0] : false;
    let sortBy =  args[1] ? args[1] : 'title';
    let defaultSort =  args[2] ? args[2] : 'title';

    sortable.sort(function (a, b) {
      let aSort = get(a, sortBy) ? get(a, sortBy) : get(a, defaultSort);
      let bSort = get(b, sortBy) ? get(b, sortBy) : get(b, defaultSort);
      if(aSort.constructor.name == "String") aSort = aSort.toLowerCase();
      if(bSort.constructor.name == "String") bSort = bSort.toLowerCase();

      if(sortInGroups) {
        if (a.course_order_group.order == b.course_order_group.order) {
          if (aSort < bSort) { return -1; }
          if (aSort < bSort) { return 1; }
          return 0;
        }
        if (a.course_order_group.order < b.course_order_group.order) { return -1; }
        if (a.course_order_group.order > b.course_order_group.order) { return 1; }
      } else {
        if (aSort < bSort) { return -1; }
        if (aSort > bSort) { return 1; }
        return 0;
      }
      
    });
    return sortable;
  }
}